import { render, staticRenderFns } from "./SkuMateriales.vue?vue&type=template&id=36e66354&scoped=true&"
import script from "./SkuMateriales.vue?vue&type=script&lang=js&"
export * from "./SkuMateriales.vue?vue&type=script&lang=js&"
import style0 from "./SkuMateriales.vue?vue&type=style&index=0&id=36e66354&prod&lang=scss&scoped=true&"
import style1 from "./SkuMateriales.vue?vue&type=style&index=1&id=36e66354&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e66354",
  null
  
)

export default component.exports